<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div class="row">
      <div class="col-4">
        <div class="label col-5">วันที่</div>
        <date-picker v-model="daterange" type="daterange"></date-picker>
      </div>
      <div class="col-3">
        <div class="label">โครงการ</div>
        <project-select v-model="query.project" :selectedProjectId="setProject" @defaultProject="handleChange"></project-select>
      </div>
      <div class="col-2">
        <div class="label">ทะเบียนรถ</div>
        <el-input v-model="query.licensePlate" />
      </div>
      <div class="col-3">
        <div class="label">ชื่อลูกค้า</div>
        <el-input v-model="query.customerName" />
      </div>
    </div>
    <div class="search">
      <div class="text-right mt-2 pr-2">
        <sc-button variant="warning" @click="handleClickClear">clear</sc-button>
      </div>
      <div class="mt-2">
        <sc-button variant="primary" @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
    </div>

    <div>
      <div class="text-center" v-if="!total">ไม่มีข้อมูล</div>
      <div>
        <div class="test-left" style="float: left">
          <p class="mb-1 mt-2">{{ totalCount }}</p>
        </div>

        <div class="text-right" style="float: right">
          <button variant="secondary" @click.prevent="handleClickDownloadAsCSV">
            Download
          </button>
        </div>
        <div style="clear: both"></div>
        <div class="session-row header">
          <div class="cell">โครงการ</div>
          <div class="cell">บ้านเลขที่</div>
          <div class="cell">ชื่อลูกค้า</div>
          <div class="cell">เครื่องชาร์จ</div>
          <div class="cell">ทะเบียนรถ</div>
          <div class="cell">รุ่นรถ</div>
          <div class="cell">วัน-เวลา เข้าจอด</div>
          <div class="cell">วัน-เวลา ออก</div>
          <div class="cell">ชั่วโมง</div>
          <div class="cell">นาที</div>
          <div class="cell">ปริมาณไฟฟ้า</div>
        </div>
        <div class="mb-4">
          <div class="session-row" v-for="usage in usageList" :key="usage.key">
            <div class="cell">{{ usage.projectName }}</div>
            <div class="cell">{{ usage.addressNo }}</div>
            <div class="cell">{{ usage.userName }}</div>
            <div class="cell">{{ usage.stationName }}</div>
            <div class="cell">{{ usage.licensePlate }}</div>
            <div class="cell">{{ usage.carName }}</div>
            <div class="cell">{{ usage.parkedAt }}</div>
            <div class="cell">{{ usage.expiredAt }}</div>
            <div class="cell">{{ usage.hours }}</div>
            <div class="cell">{{ usage.minutes }}</div>
            <div class="cell">{{ usage.totalCharging }}</div>
          </div>
        </div>
        <div class="text-right">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :size="10"
            :current-page="+query.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../../../lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import { Row, Col } from "element-ui";
import { evUseCase } from "../EvUseCase";
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import ProjectSelect from "@/lib/components/ProjectSelect";
import { Input, Pagination, Select, Option } from "element-ui";
import DatePicker from "@/lib/components/DatePicker";
import ScButton from "@/lib/components/ScButton";
import { getDownloadedReport } from "@/god";

export default {
  name: "EvReportPage",
  components: {
    PageWrapper,
    ProjectSelect,
    DatePicker,
    ScButton,
    "el-row": Row,
    "el-col": Col,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
  },
  data() {
    const pageWrapper = {
      title: "EV Parking Report",
      hasPad: true,
    };
    const stations = [];
    const query = {
      project: null,
      licensePlate: null,
      customerName: null,
      projectId: null,
      page: 1,
    };

    return {
      pageWrapper,
      usageList: [],
      total: 1,
      query,
      daterange: [],
    };
  },
  computed: {
    setProject() {
      return this.$route.query.projectId
    },
    queryParams() {
      const { project, licensePlate, customerName, from, to, page, projectId } =
        this.$route.query;

      return {
        from,
        to,
        project,
        licensePlate,
        customerName,
        projectId,
        page,
      };
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.usageList.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = +this.query.page || 1;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setup();
    },
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const { from, to } = this.$route.query;
      this.query = {
        projectId: this.$route.query.projectId || null,
        project: this.$route.query.project || null,
        customerName: this.$route.query.customerName || null,
        licensePlate: this.$route.query.licensePlate || null,
        page: this.$route.query.page || 1,
        from: this.$route.query.from || null,
        to: this.$route.query.to || null,
      };
      this.daterange = [DateTime.fromISO(from), DateTime.fromISO(to)];
    },
    setupData() {
      this.setupUsageList();
    },
    async setupUsageList() {
      const { count, histories } = await this.fetchData();
      const usageList =
        histories &&
        histories.length > 0 &&
        histories.map((usage) => {
          const projectName = usage.project_name;
          const addressNo = usage.address_no;
          const userName = `${usage.first_name} ${usage.last_name}`;
          const stationName = usage.name;
          const licensePlate = usage.car_license;
          const carName = usage.car_name;
          const parkedAt = usage.parked_at;
          const expiredAt = usage.exited_at;
          let hours = "-";
          let minutes = "-";
          let totalCharging = "-";
          if (usage.parked_duration) {
            hours = usage.parked_duration.hours;
            minutes = usage.parked_duration.minutes;
            totalCharging = usage.total_charging_kwh;
          }

          return {
            projectName,
            addressNo,
            userName,
            stationName,
            licensePlate,
            carName,
            parkedAt,
            expiredAt,
            hours,
            minutes,
            totalCharging,
          };
        });

      this.usageList = usageList;
      this.total = count;
    },
    async fetchData() {
      const params = {
        project_id:
          this.query.projectId
            ? this.query.projectId
            : null,
        license_plate: this.query.licensePlate || null,
        customer_name: this.query.customerName || null,
        page: this.query.page || null,
        from: this.query.from || null,
        to: this.query.to || null,
      };

      try {
        const response = await baanRueJaiClient.admin.ev.getReport(params);

        return response.data.result;
      } catch (error) {
        throw error;
      }
    },
    handleClickClear() {
      this.daterange = "";
      this.query = {
        project: null,
        licensePlate: null,
        customerName: null,
      };
    },
    handleClickSearch() {
      let fromIso;
      let toIso;


      if (this.daterange.length > 0) {
        const [from, to] = this.daterange;
        fromIso = from.toISO();
        toIso = to.toISO();
      }

      const query = {
        from: fromIso,
        to: toIso,
        project: this.query.project,
        projectId: (this.query.project)
          ? this.query.project.projectId
          : null,
        licensePlate: this.query.licensePlate,
        customerName: this.query.customerName,
        page: 1,
      };

      this.$router.push({ query });
    },
    handleCurrentChange(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router.push({ query });
    },
    handleChange(defaultProject) {
     this.query.project = defaultProject;
    },
    async handleClickDownloadAsCSV(event) {
      event.preventDefault();
      
      const params = {
        project_id:
          this.$route.query.projectId
            ? this.$route.query.projectId
            : null,
        license_plate: this.$route.query.licensePlate || null,
        customer_name: this.query.customerName || null,
        page: this.$route.query.page || null,
        from: this.$route.query.from || null,
        to: this.$route.query.to || null,
        format: "xlsx",
      };
      const response = await baanRueJaiClient.admin.ev.getReport(params);
      const now = DateTime.now().toFormat("yyyyMMddHHmm");
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `ev-reports-${now}.xlsx`;
      link.click();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: ($space / 2) $space;
}

.session-row {
  display: grid;
  grid-gap: $space;
  grid-template-columns: 100px 80px 100px 100px 80px 80px 100px 100px 40px 40px 60px;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    color: #999;
    font-size: 14px;
  }

  > .status {
    text-align: center;
  }
}

.search {
  display: grid;
  grid-template-columns: 94% auto;
  border-bottom: $border;
}

.link {
  display: inline-block;
  opacity: 1;

  &.back-page {
    font-weight: normal;
    color: #999;
    font-size: 20px;
  }

  &.name {
    font-weight: bold;
    font-size: 22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/features/ev-parking/pages/EvReportPage.vue